import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import 'swiper/css';

gsap.registerPlugin(ScrollTrigger);

let alreadyConverted = false;

const slideOptions = {
  slidesPerView: 1.15,
  centeredSlides: true,
  spaceBetween: 15,
}

function mobileSlider() {
  if (alreadyConverted) return; //only convert once
  if (window.innerWidth > 768) return; //only convert on mobiles

  alreadyConverted = true;
  const $ = jQuery;

  $('.progress-panels').each(function () {
    const $theBlock = $(this);
    const $theSlider = $('<div class="progress-slider"></div>');
    const $swiperWrapper = $('<div class="swiper-wrapper"></div>');
    const $items = $('.progress-panel', $theBlock);

    // Move nav to swiper
    $items.each(function () {
      const $item = $(this);

      const $swiperSlide = $('<div class="swiper-slide"></div>');
      const $progressPanel = $('<div class="progress-panel"></div>');
      // append
      $progressPanel.append($item.html());
      $swiperSlide.append($progressPanel[0].outerHTML);
      // $('.progress-panel', $swiperSlide).removeClass('is-hidden animated');
      $swiperWrapper.append($swiperSlide);
    })

    $swiperWrapper.append('<div class="deco"></div>');

    $theSlider.prepend($swiperWrapper);
    $theBlock.append($theSlider);

    // Enable swiper
    const swiper = new Swiper($theSlider[0], slideOptions);

    // On windows resize adjust swiper decorations
    setTimeout(function (){
      $('.deco', $theBlock).css('width', $('.swiper-slide', $theBlock).last().position().left + 'px');
    })
    $(window).on('resize', function () {
      $('.deco', $theBlock).css('width', $('.swiper-slide', $theBlock).last().position().left + 'px');
    } );
  });
}

let isLoaded = false;
function ProgressPanels() {
  const $ = jQuery;

  console.log('ProgressPanels');

  // Add connecting lines and dots
  $('.progress-panels  .desktop-version').each(function (){
    let $panelsContainer = $(this);
    let $panels = $('.progress-panel', $panelsContainer);
    let $panelsCount = $panels.length;

    $panels.each(function (index){
      let animationDelay;

      switch (index % 3) {
        case 0:
          animationDelay = 0;
          $(this).addClass('first');

          switch ($panelsCount - index) {
            case 1:
              $(this).addClass('leaf-of-one');
              break;
            case 2:
              $(this).addClass('leaf-of-two');
              break;
            default: // >= 3
              $(this).addClass('leaf-of-three');
              break;
          }
          break;
        case 1:
          animationDelay = 1;
          $(this).addClass('second');
          break;
        case 2:
          animationDelay = 2;
          $(this).addClass('third');
          break;
      }

      let $thisBlock = $(this);

      // pre animation states
      gsap.set($thisBlock, {x: 40, '--connector-width':'116px'});



      let panelTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: $thisBlock,
          start: "30% bottom", //start when 50% of the element gets above the BOTTOM of the screen
          end: "bottom top", //stop when the BOTTOM part of the element gets above the TOP part of the screen
        },
      });

      panelTimeline.to($('.connector .svg.' + ((animationDelay === 0) ? 'right':'left'), $thisBlock), {opacity:1, duration:0.3}, animationDelay);
      panelTimeline.set($thisBlock, {onComplete: function(){$('.connector', $thisBlock).addClass('show-line')}});
      if (animationDelay === 0) { // long line animation duration for first block
        panelTimeline.to($thisBlock, {duration:1});
      } else { // short line animation duration for other blocks
        panelTimeline.to($thisBlock, {duration:0.3});
      }
      panelTimeline.to($('.connector .svg.' + ((animationDelay === 0) ? 'left':'right'), $thisBlock), {opacity:1, duration:0.3});
      panelTimeline.to($thisBlock, {
        x:0, '--connector-width':'76px',
        'outline-color':'#007681',
        duration:0.5
      });
      panelTimeline.to($('.icon', $thisBlock), {backgroundColor:'#007681', duration:0.5}, "-=0.3");
      panelTimeline.set($thisBlock, {onComplete: function(){$thisBlock.removeClass('is-hidden')}}, "-=0.1"  );
    });

    // Adjust scale on window resize
    $(window).on('resize', function (){
      // if window below 1360
      if (window.innerWidth < 930) {
        $panelsContainer.css('--scale-factor', 0.6);
      } else if (window.innerWidth < 1100) {
        $panelsContainer.css('--scale-factor', 0.7);
      } else if (window.innerWidth < 1360) {
        $panelsContainer.css('--scale-factor', 0.8);
      }

    } );
  });

  // convert panels to slider for mobile devices
  mobileSlider();
  // on resize same
  $(window).on('resize', function() {
    mobileSlider();
  });
}

export { ProgressPanels };
